import { Button, message, Space, Badge } from 'antd';
import './downCenter.less';
const ellipsis = {
	ellipsis: true,
	scopedSlots: { customRender: 'ellipsis' }
};

function downFile(urlList) {
	if (Array.isArray(urlList) && urlList.length > 0) {
		// 遍历 URL 列表，逐一下载
		urlList.forEach((url) => {
			// 使用 window.location.href 下载文件
			//window.location.href = url; // 直接通过 href 进行下载，触发浏览器下载文件

			// 如果需要在新窗口打开文件（有时会避免页面重定向问题），可以使用 window.open：
			if (url) {
				window.open(url);
			} else {
				message.error('下载失败');
			}
		});
	} else {
		console.warn('URL列表为空或无效');
	}
}

export const configcolumn = [
	{
		title: '序号',
		render: (texe, record, index) => <Space>{index + 1}</Space>,
		width: 80,
		align: 'center'
	},
	{
		title: '任务名称',
		dataIndex: 'taskName',
		key: 'taskName',
		width: 180,
		...ellipsis
	},
	{
		title: '任务状态',
		dataIndex: 'statusName',
		key: 'statusName',
		width: 112,
		align: 'center',
		render: (_, record) => (
			<div>
				<Badge
					color={record.statusCode === '1083015' ? '#0DD78D' : record.statusCode === '1083020' ? '#FD5451' : '#faad14'}
				/>
				{record.statusName}
			</div>
		)
	},
	{
		title: '下载成功文件',
		dataIndex: '',
		key: 'successDownLoad',
		width: 144,
		align: 'center',
		render: (_, record) => (
			<div className="tabBtn">
				{
					record.taskFileNetworkUrls &&
					Array.isArray(record.taskFileNetworkUrls) &&
					record.taskFileNetworkUrls.length > 0 ? ( // 判断是否为非空数组
						<Button
							type="link"
							onClick={() => {
								downFile(record.taskFileNetworkUrls); // 使用正确的字段
							}}>
							<span className="downBtn"> 下载中心</span>
						</Button>
					) : null // 如果是 null 或 空数组，不显示按钮
				}
			</div>
		)
	},
	{
		title: '下载失败原因',
		dataIndex: 'interruptMessage',
		key: 'interruptMessage',
		width: 150,
		...ellipsis
	},
	{
		title: '创建时间',
		dataIndex: 'createTime',
		key: 'createTime',
		width: 180,
		align: 'center'
	}
	// {
	// 	title: '操作',
	// 	key: 'action',
	// 	align: 'center',
	// 	fixed: 'right',
	// 	width: 60,
	// 	render: (_, record) => (
	// 		<div className="tabBtn">
	// 			<Popconfirm
	// 				title="是否确认删除?"
	// 				onConfirm={deleteData(record.id)}
	// 				onCancel={cancel}
	// 				okText="是"
	// 				cancelText="否">
	// 				<Button type="link"> 删除 </Button>
	// 			</Popconfirm>
	// 		</div>
	// 	)
	// }
];
